export default "__VITE_ASSET__13516b84__"